export const changeStylePVPR = () => {

  function downPrice() {
    jQuery('article.dkt-product').each(
      function checkPVPR() {
        const sticker = jQuery(this).find('.dkt-product__sticker__sticker');
        const stickerPVPR = jQuery(this).find('.dkt-price__price-reco-title');
        if (sticker.html() !== '¡ÚLTIMAS UNIDADES!' && sticker.html() !== '¡ULTIMES UNITATS!' && jQuery(this).data('check') !== 'checked') {
          if (stickerPVPR.html() === 'PRIX PUBLIC CONSEILLE' || stickerPVPR.html() === 'PRECIO RECOMENDADO') {
            // get current price
            const currentPrice = jQuery(this).find('.dkt-price__cartridge').data('price');
            // get pvpr price from string and convert to float
            let stringPrice = jQuery(this).find('.dkt-price__price-reco').html().split('€')[1];
            if (window.location.origin.indexOf('localhost') >= 0) {
              stringPrice = stringPrice.replace('.,', ',');
            }
            let decimalPrice = stringPrice.split(',')[0];
            decimalPrice=decimalPrice.split('.').join('');
            const centPrice = stringPrice.split(',')[1].split('<span')[0];
            const pvprPrice = parseFloat(`${decimalPrice}.${centPrice}`);
            // get product discount
            const discountPercentage = Math.trunc([(pvprPrice - currentPrice) * 100] / pvprPrice);

            jQuery(this).find('.dkt-price').prepend(`<span class="dkt-price__info-addon"><span style="font-weight:bold;">PVPR </span><span class="dkt-price__previous-price" style="text-decoration: none;">€${pvprPrice.toString().replace('.', ',')}</span><span class="dkt-price__reduction" style="margin-left: 2px;">-${discountPercentage}%</span></span>`);

            jQuery(this).data('check', 'checked');
          }
        }

        jQuery(this).find('.dkt-price__price-reco').remove();
        jQuery(this).find('.dkt-price__legal-addon').remove();
      }
    );
  };

  function downPriceTG() {
    jQuery('#spotlightFloor .pl-element').each(
      function checkPVPR() {
        const sticker = jQuery(this).find('.dkt-product__sticker__sticker');
        const stickerPVPR = jQuery(this).find('.dkt-price__price-reco-title');
        if (sticker.html() !== '¡ÚLTIMAS UNIDADES!' && sticker.html() !== '¡ULTIMES UNITATS!' && jQuery(this).data('check') !== 'checked') {
          if (stickerPVPR.html() === 'PRIX PUBLIC CONSEILLE' || stickerPVPR.html() === 'PRECIO RECOMENDADO') {
            // get current price
            const currentPrice = jQuery(this).find('.dkt-price__cartridge').data('price');
            // get pvpr price from string and convert to float
            let stringPrice = jQuery(this).find('.dkt-price__price-reco').html().split('€')[1];
            if (window.location.origin.indexOf('localhost') >= 0) {
              stringPrice = stringPrice.replace('.,', ',');
            }
            let decimalPrice = stringPrice.split(',')[0];
            decimalPrice=decimalPrice.split('.').join('');
            const centPrice = stringPrice.split(',')[1].split('<span')[0];
            const pvprPrice = parseFloat(`${decimalPrice}.${centPrice}`);
            // get product discount
            const discountPercentage = Math.trunc([(pvprPrice - currentPrice) * 100] / pvprPrice);

            jQuery(this).find('.dkt-price').prepend(`<span class="dkt-price__info-addon"><span style="font-weight:bold;">PVPR </span><span class="dkt-price__previous-price" style="text-decoration: none;">€${pvprPrice.toString().replace('.', ',')}</span><span class="dkt-price__reduction" style="margin-left: 2px;">-${discountPercentage}%</span></span>`);

            jQuery(this).data('check', 'checked');
          }
        }

        jQuery(this).find('.dkt-price__price-reco').remove();
        jQuery(this).find('.dkt-price__legal-addon').remove();
      }
    );
  };

  function changeSliderPVPRstyle() {
    jQuery('.pl-list--cross-sell .plv2-element').each(
      function checkPVPR() {
        const sticker = jQuery(this).find('.dkt-product__sticker__sticker');
        const element = jQuery(this).find('.dkt-price .dkt-price__price-reco');
        if (sticker.html() !== '¡ÚLTIMAS UNIDADES!' && sticker.html() !== '¡ULTIMES UNITATS!' && element.length > 0) {
          // get current price
          const currentPrice = jQuery(this).find('.dkt-price .dkt-price__cartridge').data('price');
          // get pvpr price from string and convert to float
          let stringPrice = element.html().split('€')[1];
          if (window.location.origin.indexOf('localhost') >= 0) {
            stringPrice = stringPrice.replace('.,', ',');
          }
          let decimalPrice = stringPrice.split(',')[0];
          decimalPrice=decimalPrice.split('.').join('');
          const centPrice = stringPrice.split(',')[1].split('<span')[0];
          const pvprPrice = parseFloat(`${decimalPrice}.${centPrice}`);
          // get product discount
          const discountPercentage = Math.trunc([(pvprPrice - currentPrice) * 100] / pvprPrice);

          element.remove();
          jQuery(this).find('.plv2-el__price a').prepend(`<span class="dkt-price__info-addon"><span class="dkt-price__previous-price" style="text-decoration: none;">PVPR €${pvprPrice.toString().replace('.', ',')}</span><span class="dkt-price__reduction"> -${discountPercentage}%</span></span>`);
        } else {
          jQuery(this).find('.dkt-price .dkt-price__price-reco').remove();
          jQuery(this).find('.dkt-price .dkt-price__legal-addon').remove();
        }
      }
    );
  };

  jQuery(document).ajaxSuccess((event, xhr, settings) => {
    if (settings.url.split('?')[0].indexOf('/ajax/reloadCartridgeContentCollection') >= 0 || settings.url.split('?')[0].indexOf('/ajax/loadCartridge') >= 0) {
      downPrice();
      downPriceTG();
    }
  });

  downPrice();
  downPriceTG();
  changeSliderPVPRstyle();
};

export const changeSliderPVPRstyle = () => {
  jQuery('.pl-list--cross-sell .plv2-element').each(
    function checkPVPR() {
      const sticker = jQuery(this).find('.dkt-product__sticker__sticker');
      const element = jQuery(this).find('.dkt-price .dkt-price__price-reco');
      if (sticker.html() !== '¡ÚLTIMAS UNIDADES!' && sticker.html() !== '¡ULTIMES UNITATS!' && element.length > 0) {
        // get current price
        const currentPrice = jQuery(this).find('.dkt-price .dkt-price__cartridge').data('price');
        // get pvpr price from string and convert to float
        let stringPrice = element.html().split('€')[1];
        if (window.location.origin.indexOf('localhost') >= 0) {
          stringPrice = stringPrice.replace('.,', ',');
        }
        let decimalPrice = stringPrice.split(',')[0];
        decimalPrice=decimalPrice.split('.').join('');
        const centPrice = stringPrice.split(',')[1].split('<span')[0];
        const pvprPrice = parseFloat(`${decimalPrice}.${centPrice}`);
        // get product discount
        const discountPercentage = Math.trunc([(pvprPrice - currentPrice) * 100] / pvprPrice);

        element.remove();
        jQuery(this).find('.plv2-el__price a').prepend(`<span class="dkt-price__info-addon"><span class="dkt-price__previous-price" style="text-decoration: none;">PVPR €${pvprPrice.toString().replace('.', ',')}</span><span class="dkt-price__reduction"> -${discountPercentage}%</span></span>`);
      } else {
        jQuery(this).find('.dkt-price .dkt-price__price-reco').remove();
        jQuery(this).find('.dkt-price .dkt-price__legal-addon').remove();
      }
    }
  );
};

export const changeShippingDelayForIconProductsArticle = () => {
  let iconList = [];
  /* eslint-disable global-require */
  if (window.location.origin.indexOf('localhost') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {
    iconList = require('./json/iconProductsList.json');
    jQuery('article.dkt-product').each(function checkItem() {
      const id_model = parseInt(jQuery(this).find('.dkt-product-slider__slide--active').attr('data-reference-id'), 10);
      if (iconList.iconList.includes(id_model)) {
        jQuery(this).find('.dkt-product__availability.dkt-product__leadtime').html('Disponible online: Entrega en 7 días');
      }
    });

  } else {
    fetch('/static/json/iconProductsList.json')
      .then(response => response.json())
      .then(json => {
        jQuery('article.dkt-product').each(function checkItem() {
          const id_model = parseInt(jQuery(this).find('.dkt-product-slider__slide--active').attr('data-reference-id'), 10);
          if (json.iconList.includes(id_model)) {
            jQuery(this).find('.dkt-product__availability.dkt-product__leadtime').html('Disponible online: Entrega en 7 días');
          }
        });
      }).catch(() => {
        // Error :(
      });
  }
};

export const changeShippingDelayForIconProductsTG = () => {
  let iconList = [];
  /* eslint-disable global-require */
  if (window.location.origin.indexOf('localhost') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {
    iconList = require('./json/iconProductsList.json');
    jQuery('.pl-element').each(function checkTg() {
      const id_model = parseInt(jQuery(this).find('.img-product-item').attr('data-reference-id'), 10);
      if (iconList.iconList.includes(id_model)) {
        jQuery(this).find('.online-stock-info-message').html('Disponible online: Entrega en 7 horas');
      }
    });

  } else {
    fetch('/static/json/iconProductsList.json')
      .then(response => response.json())
      .then(json => {
        jQuery('.pl-element').each(function checkTg() {
          const id_model = parseInt(jQuery(this).find('.img-product-item').attr('data-reference-id'), 10);
          if (json.iconList.includes(id_model)) {
            jQuery(this).find('.online-stock-info-message').html('Disponible online: Entrega en 7 horas');
          }});
      }).catch(() => {
      // Error :(
      });
  }
};


function fixErrorJsonFilter() {
  try {
    JSON.parse(jQuery('.plp-top__description__body').text());
    jQuery('.plp-top__description__body').remove();
    // eslint-disable-next-line no-empty
  } catch (e) {}
}

fixErrorJsonFilter();



// WEBPACK FOOTER //
// ./src/_override/catalog/listingPage/es-listing.js